module.exports = __webpack_public_path__ + "static/img/company-info-pc.6e04ddf.png";